/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";

import logoPortada from "assets/images/eam/logoPortada.png";

function Information() {
  return (
    <MKBox component="section" py={8}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={12}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    title="Espacio Alma Nativa"
                    description="Aquí nos preocupamos de ti y del medio ambiente, ocupamos productos amigables con tu piel y nuestro entorno, libres de crueldad animal y veganos."
                  />
                </MKBox>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    title=""
                    description="Con nosotros podrás encontrar el lugar perfecto para relajarte, desconectarte, cuidar tu piel y tu cuerpo, en pleno centro de Viña del Mar."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={logoPortada}
              title="Relajo y cuidado Personal"
              description="Tratamientos con productos Veganos & Cruelty free."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
